import { RichTextEditor as MantineRichTextEditor, RichTextEditorControlProps } from "@mantine/tiptap";
import clsx from "clsx";
import { FunctionComponent } from "react";
import styles from "../rich-text-editor.module.scss";
import { faUnderline } from "@fortawesome/pro-solid-svg-icons";
import { Icon } from "../../icon";
import { useEditorDisabled } from "../use-editor-disabled";

const UnderlineIcon = () => <Icon icon={faUnderline} size="xs" />;

export const Underline: FunctionComponent<RichTextEditorControlProps> = ({ className, disabled, ...other }) => {
    const effectiveDisabled = useEditorDisabled(disabled);
    return (
        <MantineRichTextEditor.Underline
            className={clsx(styles["control"], className)}
            disabled={effectiveDisabled}
            {...other}
            icon={UnderlineIcon}
        />
    );
};

Underline.displayName = "RichTextEditor.Underline";
